export default {
  mounted(el) {
    const input = el.querySelector("input");

    if (!input) return;

    const format = (value) => {
      if (!value) return "";

      let raw = value.replace(/[^\d]/g, "");

      if (!raw) return "";

      let number = (parseInt(raw, 10) / 100).toFixed(2);

      let [intPart, decPart] = number.split(".");

      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return `${intPart},${decPart}`;
    };

    let isFormatting = false 

    input.addEventListener("input", () => {
      if (isFormatting) return  

      isFormatting = true

      const cursor = input.selectionStart
      input.value = format(input.value)
      input.dispatchEvent(new Event("input"))
      input.setSelectionRange(cursor, cursor)

      isFormatting = false
    });
  }
};